export default __webpack_public_path__ + "static/media/coming_soon2.56fffa38.png";